// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1445":"fb129902","1591":"0a222eef","6267":"dfd8f373"}[chunkId] + ".chunk.css";
};